import type {SearchRules} from '../../types';
import {SearchTypeAI} from '../constants';

/**
 * Check if rules contain specified ai search type
 * @param searchRules Search rules
 * @returns Contains ai search type
 */
export const rulesContainAI = (searchRules: Partial<SearchRules>) =>
	!!searchRules.elementTypes &&
	searchRules.elementTypes.some((elementType) => elementType === SearchTypeAI);

export default rulesContainAI;
